module.exports = __webpack_public_path__ + "static/media/research-schedule-full.99d5e46c.png";